import React from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { Stack, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

interface Props {
  title: string;
  value: string | number;
  Icon: React.ElementType;
  color: string;
  disabled: boolean;
}

export default function CardView({
  title,
  value,
  Icon,
  color,
  disabled,
}: Props) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: mobile ? "row" : "column",
        alignItems: mobile ? "center" : "flex-start",
        justifyContent: mobile ? "flex-start" : "space-between",
        px: mobile ? 1.5 : 2,
        py: mobile ? 1.5 : 2,
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        opacity: disabled ? 0.5 : 1,
        minHeight: mobile ? 64 : 100,
        marginBottom: mobile ? 1.5 : 0,
        width: "100%",
        maxWidth: mobile ? "100%" : 260,
      }}
    >
      <Box
        sx={{
          mr: mobile ? 2 : 0,
          mb: mobile ? 0 : 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon
          sx={{
            fontSize: mobile ? 32 : 40,
            color: "#fff",
            backgroundColor: color,
            borderRadius: 2,
            padding: mobile ? 0.5 : 1,
            boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
          }}
        />
      </Box>
      <Stack spacing={0.5} sx={{ flex: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: mobile ? 11 : 13,
            color: theme.palette.text.secondary,
            fontWeight: 500,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontSize: mobile ? 22 : 26,
            fontWeight: 700,
            color: theme.palette.text.primary,
            lineHeight: 1.1,
          }}
        >
          {value}
        </Typography>
      </Stack>
    </Card>
  );
}
